module.exports = __webpack_public_path__ + "static/media/youtube.f43e11b1.svg";